module.exports = __webpack_public_path__ + "static/img/A.a29af65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/A.png
// module id = hwEv
// module chunks = 0